import React, {useState} from 'react';
import Button from "./button/completeSolutionButton";
import './completeSolutionSection.scss'
import Calendar from '@images/homepage/completeSolution/icons/calendar.svg'
import Customizable from '@images/homepage/completeSolution/icons/customizable.svg'
import Finances from '@images/homepage/completeSolution/icons/finances.svg'
import Responsive from '@images/homepage/completeSolution/icons/responsive.svg'
import Security from '@images/homepage/completeSolution/icons/security.svg'
import ToggleSwitch from "@components/common/toggleSwitch/homepage/toggleSwitch";
import {graphql, useStaticQuery} from "gatsby";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {getRedirectionLink, pushToDataLayer} from "../../../utils/redirectToTryForFree";
import ButtonLink from "../../common/buttonLink/buttonLink";

function CompleteSolutionSection() {

  const query = useStaticQuery(graphql`{
    allFile(filter: {sourceInstanceName: {eq: "solutions"}}, sort: {name: ASC}) {
    edges {
      node {
        id
        name
        childImageSharp {
          gatsbyImageData (
          quality: 100,
          outputPixelDensities: 2, 
          placeholder: NONE,
          backgroundColor: "#00092d",
          width: 788
          )
          fixed(width: 780) {
            base64
            tracedSVG
            aspectRatio
            srcWebp
            srcSetWebp
            originalName
          }
        }
      }
    }
   }
  }`)

  let templateImages = query.allFile.edges.map((item) => (
    getImage(item.node.childImageSharp.gatsbyImageData)
  ))

  let [theme, setTheme] = useState(false);
  const [booking, setBooking] = useState(true);
  const [dashboard, setDashboard] = useState(false);

  const handleBooking = () => {
    setBooking(true);
    setDashboard(false)
  }

  const handleDashboard = () => {
    setDashboard(true);
    setBooking(false);
    setTheme(true)

  }

  const onThemeChange = (checked) => {
    setTheme(checked);
  };

  const advantages = [
    {
      'icon': Responsive,
      'title': 'Responsive',
      'description': 'Manage your business on your mobile while you are lying on your cozy couch. Let your clients book appointments the same way.',
      'booking': true
    },
    {
      'icon': Customizable,
      'title': 'Customizable',
      'description': 'Design the perfect booking experience. Choose from predefined light and dark themes and fine-tune them to your preferences with various customization options, creating a booking page that aligns with your brand.',
      'booking': true
    },
    {
      'icon': Security,
      'title': 'Business performance',
      'description': 'The Trafft dashboard provides important reports and dashboards to help you track your business\'s performance through vital KPIs and statistics.',
      'booking': false
    },
    {
      'icon': Finances,
      'title': 'Finances',
      'description': 'Automatically send and generate invoices with taxes, along with a detailed billing history of online or on-site transactions. Save and organize your revenue information efficiently.',
      'booking': false
    },
    {
      'icon': Calendar,
      'title': 'Backend calendar',
      'description': 'An insightful appointments calendar that offers information and previews of service durations. Easily filter by date range and employee for simplified supervision.',
      'booking': false
    }
  ];

  const isBooking = advantages.filter(advantage => advantage.booking === booking)

  return (
    <div className='homepage-cs-wrapper'>
      <div className='homepage-cs-wrapper__complete-solution'>
        <div className='homepage-cs-wrapper__complete-solution__headline'>
            <h2>The most intuitive and easy-to-use online booking system</h2>
          <div className='homepage-cs-wrapper__complete-solution__headline__subtitle'>
            No training is needed to use Trafft. You and your customers will love how simple it is to use this appointment scheduling tool
          </div>
        </div>

        <div className='homepage-cs-wrapper__complete-solution__wrapper'>
          <div className='homepage-cs-wrapper__complete-solution__wrapper__buttons'>
            <Button
              type={booking ? 'default active' : 'default'}
              label='Booking Form and Website'
              onClick={handleBooking}
            >
            </Button>
            <Button
              type={dashboard ? 'default active' : 'default'}
              label='Trafft Dashboard'
              onClick={handleDashboard}
            >
            </Button>
          </div>

          <div style={{
            transform: dashboard ? 'translate(0px,40px)' : 'translate(0px,0px)',
            opacity: dashboard ? '0' : '1',
            transition: 'all 1s'
          }} className='homepage-cs-wrapper__complete-solution__wrapper__switcher'>
            <div
              className='homepage-cs-wrapper__complete-solution__wrapper__switcher__dark'
              style={{opacity: !theme ? '1' : '0.5'}}
            >
              Dark Mode
            </div>

            <div>
              <ToggleSwitch
                id="theme"
                checked={theme}
                onChange={onThemeChange}
                disabled={dashboard}
              />
            </div>
            <div className='homepage-cs-wrapper__complete-solution__wrapper__switcher__light'
                 style={{opacity: theme ? '1' : '0.5'}}
            >
              Light Mode
            </div>
          </div>

          <div className='homepage-cs-wrapper__complete-solution__wrapper__image-and-text'>
            <div
              style={{maxWidth: '788px', transform: dashboard ? 'translate(0px,-60px)' : 'translate(0px,0px)', transition: 'all 1s'}}
              className='homepage-cs-wrapper__complete-solution__wrapper__image-and-text__image'>
              <GatsbyImage alt={booking ? 'Trafft booking form' : 'Trafft appointments dashboard'} image={booking ? (theme ? templateImages[1] : templateImages[0]) : dashboard ? (theme ? templateImages[2] : templateImages[2]) : ''} />
            </div>

            {isBooking &&
              <div style={{transform: dashboard ? 'translate(0px,-60px)' : 'translate(0px,0px)', transition: 'all 1s'}}
                   className='homepage-cs-wrapper__complete-solution__wrapper__image-and-text__text'>
                {isBooking.map((advantage) =>
                  <div key={advantage.title}
                       className='homepage-cs-wrapper__complete-solution__wrapper__image-and-text__text__advantages'>
                    <div className='homepage-cs-wrapper__complete-solution__wrapper__image-and-text__text__advantages__icon'>
                      <img src={advantage.icon} alt={advantage.title} loading="lazy"/>
                    </div>
                    <div className='homepage-cs-wrapper__complete-solution__wrapper__image-and-text__text__advantages__text'>
                        <h3>{advantage.title}</h3>
                      <div
                        className='homepage-cs-wrapper__complete-solution__wrapper__image-and-text__text__advantages__text__description'>
                        {advantage.description}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            }
          </div>
          <ButtonLink
            href={getRedirectionLink()}
            onClick={pushToDataLayer}
            label="Get started for free"
            target="_blank"
            extraClass='primary'
          />
        </div>
      </div>
    </div>
  )
}

export default CompleteSolutionSection